<template>
  <div>
    <main-header/>
    <div class="currentBag-bg">
      <nav-bar class="d-md-block d-none"/>
      <div class="pt-10">
        <div class="container currentBag-grayBorder p-0">
          <div class="gray-bg">
            <div class="text-center font-weight-bold py-5 font-18">سوابق سفارش</div>
          </div>
          <div class="row mt-3">
            <div class="col mx-3">
              <div class="table-responsive text-center ">
                <table class="table table-bordered">
                  <thead>
                  <tr>
                    <th>ردیف</th>
                    <th>کد پیگیری</th>
                    <th>مبلغ کل</th>
                    <th>وضعیت سفارش</th>
                    <th>روش پرداخت</th>
                    <th>تاریخ درج</th>
                  </tr>
                  </thead>
                  <tbody v-for="(item,index) in currentBag" :key="item.InvoiceID">
                  <tr>
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.TrackingCode }}</td>
                    <td>{{ item.FactorAmount }}</td>
                    <td>{{ status[item.InvoiceStatus] }}</td>
                    <td>{{ PaymentType[item.PaymentType] }}</td>
                    <td>{{ item.ModifiedDate }}</td>
                    <td>
                      <v-btn
                          block
                          color="primary"
                          elevation="0"
                          @click="customerDescription(item.UserDescription)">
                        توضیحات مشتری
                      </v-btn>
                      <v-btn
                          block
                          class="mt-2"
                          color="primary"
                          elevation="0"
                          @click="systemDescription(item.SystemDescription)"
                      >
                        توضیحات سیستمی
                      </v-btn>
                    </td>
                    <td>
                      <v-btn
                          block
                          color="secondary"
                          elevation="0"
                          @click="orderDetails(item.InvoiceID)">
                        جزییات سفارش
                      </v-btn>
                      <v-btn
                          block
                          class="mt-2"
                          color="secondary"
                          elevation="0"
                          @click="customerAddress(item.DeliveryAddress)">
                        آدرس تحویل
                      </v-btn>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
    <navigation-drawer :drawer="drawer"/>
    <v-dialog
        v-model="productDetails"
        hide-overlay
        width="1000">
      <v-card class="text-center pt-5">
        <div class="text-right mr-3 font-weight-bold">جزییات سفارش</div>
        <div class="row">
          <div class="col">
            <div class="table-responsive text-center">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th>ردیف</th>
                  <th>نام کالا</th>
                  <th>قیمت <br>(تومان)</th>
                  <th>توضیحات</th>
                  <th>جمع ردیف</th>
                  <th>تعداد درخواستی</th>
                  <th>دسته بندی</th>
                  <th>زیر دسته بندی</th>
                  <th>نوع</th>
                  <th>عکس محصول</th>
                </tr>
                </thead>
                <tbody v-for="(item,index) in orderDetailDialog" :key="index">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.Name }}</td>
                  <td>{{ item.Discount }}</td>
                  <td>{{ item.Price }}</td>
                  <td>{{ item.Description }}</td>
                  <td>{{ item.TotalRow }}</td>
                  <td>{{ item.NumberNeed }}</td>
                  <td>{{ item.CategoryName }}</td>
                  <td>{{ item.SubCategoryName }}</td>
                  <td>
                    <v-img :src="$replaceHttps(item.PictureUrl)" height="50"
                           width="50"></v-img>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showResultDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null
import MainHeader from "./mainHeader";
import NavBar from "./navBar";
import Footer from "./Footer";
import NavigationDrawer from "./navigationDrawer";

export default {
  name: "OrderRecords",
  metaInfo() {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  components: {NavigationDrawer, Footer, NavBar, MainHeader},
  data: () => ({
    drawer: false,
    currentBag: [],
    showLoaderDialog: false,
    dialogResult: null,
    showResultDialog: false,
    productDetails: false,
    status: [
      "", "ثبت در سیستم", "در انتظار پرداخت وجه", "در حال آماده سازی", "تحویل داده شد", "کنسل شدن سفارش"
    ],
    PaymentType: [
      "", "آنلاین", "از کیف پول", "نقدی"
    ],
    orderDetailDialog: [],

  }),
  mounted() {
    _this = this
    this.getData()
  },
  methods: {

    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      console.log(this.$getUserData().token)

      let urlencoded = new URLSearchParams();

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/InvoiceManagment/ListInvoice", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            console.log('kkkkk', json)
            if (json.length > 0) {
              _this.currentBag = json

            } else {
              _this.dialogResult = "شما سفارشی ثبت نکرده اید "
              _this.showResultDialog = true
            }
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    customerDescription(text) {
      this.showResultDialog = true
      this.dialogResult = text
    },
    systemDescription(text) {
      this.showResultDialog = true
      this.dialogResult = text
    },
    customerAddress(text) {
      this.showResultDialog = true
      this.dialogResult = text
    },
    orderDetails(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("invoiceid", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/InvoiceManagment/DetailsInvoice", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            _this.productDetails = true;
            let json = JSON.parse(result)
            _this.orderDetailDialog = json


          })
          .catch(error => console.log('error', error));
    }


  }
}
</script>

<style scoped>

</style>
